import React, { useEffect, useState, useRef } from 'react'
import Header from '../Utilities/Header'
import Footer from '../Utilities/Footer'
import contact from '../Images/Contact/contact.webp'
import noida from '../Images/Contact/noida.webp'
import delhi from '../Images/Contact/delhi.webp'
import lucknow from '../Images/Contact/lucknow.webp'
import varanasi from '../Images/Contact/varanasi.webp'
import allahabad from '../Images/Contact/allahabad.webp'
import mumbai from '../Images/Contact/mumbai.webp'
import kolkata from '../Images/Contact/Kolkata.jpg'

import chandigarh from '../Images/Contact/chandigarh.webp'
import ahmedabad from '../Images/Contact/ahmedabad.webp'
import chennai from '../Images/Contact/chennai.webp'
import { Helmet } from 'react-helmet'
import emailjs from '@emailjs/browser';
import { collection, addDoc } from "firebase/firestore";
import { db } from '../AdminPanel/firebase';
import { ToastContainer, toast } from 'react-toastify'

const Lms = () => {
  return (
    <div>
      <ToastContainer />
      <Header />
      <Helmet>
        <meta charSet="utf-8" />
        <link rel="canonical" href="https://www.wisefinserv.com/contact-us" />
      </Helmet>
      <div className="contact-page">
        <div class="page-title">
          <h4>LMS Login</h4>
        </div>
        <div class="comming-soon">
          <h4>Coming Soon</h4>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Lms
